var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgQeConsultinginline = function SvgQeConsultinginline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B46D2A",
    fillRule: "evenodd",
    d: "M12 7a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2h2a2 2 0 0 1 2 2v4a1 1 0 1 1-2 0V9h-2a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2h-2v20h6a1 1 0 1 1 0 2h-6a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h2Zm2 0h8v2h-8V7Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B46D2A",
    d: "M12 14a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1Zm1 3a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2h-3Zm-1 5a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2h-4a1 1 0 0 1-1-1Zm1 3a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2h-3Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#B46D2A",
    fillRule: "evenodd",
    d: "M26.502 22.853a4.5 4.5 0 1 0-6.003 0l-1.794 5.739c-.513 1.642 1.149 3.123 2.721 2.424l2.074-.922 2.074.922c1.572.699 3.234-.782 2.721-2.424l-1.793-5.74ZM23.5 22a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Zm-1.265 2-1.621 5.188 2.886-1.282 2.886 1.282L24.765 24h-2.53Z",
    clipRule: "evenodd"
  })));
};
export default SvgQeConsultinginline;